(ns dre.i18n.views
  (:require
    [dre.i18n.events :as-alias i18n]
    [re-frame.core :as rf]))


(defn tr
  "String translation.
  Returns translation of a msg for currently selected language
  (or original msg if translation is missing).
  Message can be formatted in a goog.string.format fashion."
  [msg & format-args]
  [:<> @(rf/subscribe [::i18n/translate msg format-args])])

(defn tr-str
  "Same as `tr` but returns plain string instead of hiccup"
  [msg & format-args]
  @(rf/subscribe [::i18n/translate msg format-args]))
